// Light theme (Special Mode DE)
import LightDeAmountOfWasteSpecialModeTile from './light-de-special/abfallmenge.png';
import LightDeCityInfoSpecialMode from './light-de-special/stadtinformationen.png';
import LightDeCurrentWeatherSpecialMode from './light-de-special/aktuelles-wetter.png';
import LightDeUpcomingProjectsSpecialMode from './light-de-special/kommende-projekte.png';
import LightDeDigitalCityTourTileSpecialMode from './light-de-special/digitaler-stadtrundgang.png';
import LightDePlaceUtilizationTileSpecialMode from './light-de-special/flächennutzung.png';
import LightDeNoisePollution1TileSpecialMode from './light-de-special/lärmbelastung.png';
import LightDeParkingTileSpecialMode from './light-de-special/parken.png';
import LightDeSmartChargingTileSpecialMode from './light-de-special/smartes-laden.png';
import LightDeSmartLighting1TileSpecialMode from './light-de-special/smart-lighting.png';
import LightDeUrbanTrashCanTileSpecialMode from './light-de-special/städtische-mülleimer.png';
import LightDeEnvironment1TileSpecialMode from './light-de-special/umwelt-1.png';
import LightDeEnvironment3TileSpecialMode from './light-de-special/umwelt-3.png';
import LightDeEnvironment6TileSpecialMode from './light-de-special/umwelt-6.png';
import LightDeWaterLevelsTileSpecialMode from './light-de-special/wasserstände.png';

// Light theme (Special Mode EN)
import LightEnAmountOfWasteSpecialModeTile from './light-en-special/amount-of-waste.png';
import LightEnCityInfoSpecialMode from './light-en-special/city-info.png';
import LightEnCurrentWeatherSpecialMode from './light-en-special/current-weather.png';
import LightEnUpcomingProjectsSpecialMode from './light-en-special/upcoming-projects-1.png';
import LightEnDigitalCityTourTileSpecialMode from './light-en-special/digital-city-tour.png';
import LightEnPlaceUtilizationTileSpecialMode from './light-en-special/place-utilization.png';
import LightEnNoisePollution1TileSpecialMode from './light-en-special/noise-pollution.png';
import LightEnParkingTileSpecialMode from './light-en-special/parking.png';
import LightEnSmartChargingTileSpecialMode from './light-en-special/smart-charging.png';
import LightEnSmartLighting1TileSpecialMode from './light-en-special/smart-lighting-1.png';
import LightEnUrbanTrashCanTileSpecialMode from './light-en-special/urban-trash-cans.png';
import LightEnEnvironment1TileSpecialMode from './light-en-special/environment-1.png';
import LightEnEnvironment3TileSpecialMode from './light-en-special/environment-3.png';
import LightEnEnvironment6TileSpecialMode from './light-en-special/environment-6.png';
import LightEnWaterLevelsTileSpecialMode from './light-en-special/water-levels.png';

// Light Theme (DE)
import LightDe7DayIncidenceTile from './light-de/7-tage-inzidenz.png';
import LightDeAmountOfWasteTile from './light-de/abfallmenge.png';
import LightDeAstroClockTile from './light-de/astrouhr.png';
import LightDeBrightnessControlTile from './light-de/helligkeitssteuerung.png';
import LightDeChargingStationsTile from './light-de/lade-stationen.png';
import LightDeCitizenParticipationTile from './light-de/bürgerbeteiligung.png';
import LightDeCityInfo from './light-de/stadtinformationen.png';
import LightDeCo2Savings1Tile from './light-de/co2-einsparungen.png';
import LightDeCo2Savings2Tile from './light-de/CO2-einsparung.png';
import LightDeCoronaInformTile from './light-de/corona inform..png';
import LightDeCovid19SituationTile from './light-de/covid-19-situation.png';
import LightDeCrossfleetTile from './light-de/crossfleet.png';
import LightDeCurrentWeatherTile from './light-de/aktuelles-wetter.png';
import LightDeCustomerRequestsTile from './light-de/serviceaufträge.png';
import LightDeDataTrafficCamerasTile from './light-de/daten-verkehrskameras.png';
import LightDeDeceasedTile from './light-de/verstorbene.png';
import LightDeDigitalCityTourTile from './light-de/digitaler-stadtrundgang.png';
import LightDeDigitalFieldsOfActionTile from './light-de/digitale-handlungsfelder.png';
import LightDeDomainSpecificLanguageTile from './light-de/domänenspezifische-sprache.png';
import LightDeEnergyHistoryTile from './light-de/energie-historie.png';
import LightDeEnergyMix2020Tile from './light-de/energiemix.png';
import LightDeEnergySavingsTile from './light-de/energieeinsparung.png';
import LightDeEnergyTile from './light-de/energie.png';
import LightDeEnvironment1Tile from './light-de/umwelt-1.png';
import LightDeEnvironment2Tile from './light-de/umwelt-2-double.png';
import LightDeEnvironment3Tile from './light-de/umwelt-3.png';
import LightDeEnvironment4Tile from './light-de/umwelt-4.png';
import LightDeEnvironment5Tile from './light-de/umwelt-5.png';
import LightDeEnvironment6Tile from './light-de/umwelt-6.png';
import LightDeEventsTile from './light-de/veranstaltungen.png';
import LightDeInfectedTile from './light-de/infizierte.png';
import LightDeMobilityStationTile from './light-de/mobilitätstation.png';
import LightDeModalSplitTile from './light-de/verkehrsmittel.png';
import LightDeMyConsumptionTile from './light-de/mein-verbrauch.png';
import LightDeNetworkOfNeighborhoodsTile from './light-de/quartiersnetzwerk.png';
import LightDeNoiseMeasurementHistoryTile from './light-de/geräuschmessungsverlauf.png';
import LightDeNoisePollution1Tile from './light-de/lärmbelastung.png';
import LightDeNoisePollution2Tile from './light-de/luftqualität.png';
import LightDeNoisePollution3Tile from './light-de/lärmmessung.png';
import LightDeOpenDataPortalTile from './light-de/open-data-portal.png';
import LightDeOverviewTile from './light-de/übersicht.png';
import LightDeOwnSupplyOfEnergyTile from './light-de/eigenversorgung-energie.png';
import LightDeParkingSpacesTile from './light-de/parkhäuser.png';
import LightDeParkingTile from './light-de/parken.png';
import LightDePlaceUtilizationTile from './light-de/flächennutzung.png';
import LightDePresenceDependentLcTile from './light-de/präsenzabhängige-lichtsteuerung.png';
import LightDePublicTransportTile from './light-de/öffentlicher-verkehr.png';
import LightDeRealTimeNoiseMeasurementsTile from './light-de/echtzeit-rauschmessungen.png';
import LightDeRenewableEnergyTile from './light-de/erneuerbare-energien.png';
import LightDeSensorManagerTile from './light-de/sensormanager.png';
import LightDeSensorStationATile from './light-de/sensor-station-a.png';
import LightDeSmartChargingTile from './light-de/smartes-laden.png';
import LightDeSmartHomeTile from './light-de/intelligentes-zuhause.png';
import LightDeSmartIrrigationTile from './light-de/smarte-bewässerung.png';
import LightDeSmartLighting1Tile from './light-de/smart-lighting-1.png';
import LightDeSmartLighting2Tile from './light-de/smart-lighting-2.png';
import LightDeSmartParkingTile from './light-de/smart-parking.png';
import LightDeSmartWifiTile from './light-de/smart-wifi.png';
import LightDeSolarEnergyTile from './light-de/solarenergie.png';
import LightDeTemperatureTile from './light-de/temperatur.png';
import LightDeTestingWasteContainerTile from './light-de/abfallbehälter.png';
import LightDeTraffic1Tile from './light-de/verkehr-1.png';
import LightDeTraffic2Tile from './light-de/verkehr-2.png';
import LightDeTrafficDependentLcTile from './light-de/verkehrsabhÄngige.png';
import LightDeTrafficInformationTile from './light-de/verkehrsinformationen.png';
import LightDeUpcomingProjects1Tile from './light-de/kommende-projekte-1.png';
import LightDeUrbanTrashCanTile from './light-de/städtische-mülleimer.png';
import LightDeVaccinationsTile from './light-de/impfungen.png';
import LightDeWaterConsumptionTile from './light-de/wasserverbrauch.png';
import LightDeWaterLevelsTile from './light-de/wasserstände.png';
import LightDePulseTile from './light-de/pulse.gif';
import LightDeLogoTile from './light-de/logo-ui-solo.png';

// Light Theme (En)
import LightEn7DayIncidenceTile from './light-en/7-day-incidence.png';
import LightEnAmountOfWasteTile from './light-en/amount-of-waste.png';
import LightEnAstroClockTile from './light-en/astroclock.png';
import LightEnBrightnessControlTile from './light-en/brightness-control.png';
import LightEnChargingStationsTile from './light-en/charging-station.png';
import LightEnCitizenParticipationTile from './light-en/upcoming-projects-2.png';
import LightEnCityInfo from './light-en/city-info.png';
import LightEnCo2Savings1Tile from './light-en/CO2-savings.png';
import LightEnCo2Savings2Tile from './light-en/co2-savings-2.png';
import LightEnCoronaInformTile from './light-en/corona inform..png';
import LightEnCovid19SituationTile from './light-en/covid-19-situation.png';
import LightEnCrossfleetTile from './light-en/crossfleet.png';
import LightEnCurrentWeatherTile from './light-en/current-weather.png';
import LightEnCustomerRequestsTile from './light-en/customer-requests.png';
import LightEnDataTrafficCamerasTile from './light-en/data-traffic-cameras.png';
import LightEnDeceasedTile from './light-en/deceased.png';
import LightEnDigitalCityTourTile from './light-en/digital-city-tour.png';
import LightEnDigitalFieldsOfActionTile from './light-en/digital-fields-of-action.png';
import LightEnDomainSpecificLanguageTile from './light-en/domain-specific-language.png';
import LightEnEnergyHistoryTile from './light-en/energy-history.png';
import LightEnEnergyMix2020Tile from './light-en/energy-mix.png';
import LightEnEnergySavingsTile from './light-en/energy-savings.png';
import LightEnEnergyTile from './light-en/energy.png';
import LightEnEnvironment1Tile from './light-en/environment-1.png';
import LightEnEnvironment2Tile from './light-en/environment-2-double.png';
import LightEnEnvironment3Tile from './light-en/environment-3.png';
import LightEnEnvironment4Tile from './light-en/environment-4.png';
import LightEnEnvironment5Tile from './light-en/environment-5.png';
import LightEnEnvironment6Tile from './light-en/environment-6.png';
import LightEnEventsTile from './light-en/events.png';
import LightEnInfectedTile from './light-en/infected.png';
import LightEnMobilityStationTile from './light-en/mobility-station.png';
import LightEnModalSplitTile from './light-en/modal-split.png';
import LightEnMyConsumptionTile from './light-en/my-consumption.png';
import LightEnNetworkOfNeighborhoodsTile from './light-en/network-of-neighborhoods.png';
import LightEnNoiseMeasurementHistoryTile from './light-en/noise-measurement-history.png';
import LightEnNoisePollution1Tile from './light-en/noise-pollution.png';
import LightEnNoisePollution2Tile from './light-en/air-quality.png';
import LightEnNoisePollution3Tile from './light-en/noise-measurement.png';
import LightEnOpenDataPortalTile from './light-en/open-data-portal.png';
import LightEnOverviewTile from './light-en/overview.png';
import LightEnOwnSupplyOfEnergyTile from './light-en/own-supply-of-energy.png';
import LightEnParkingSpacesTile from './light-en/parking-spaces.png';
import LightEnParkingTile from './light-en/parking.png';
import LightEnPlaceUtilizationTile from './light-en/place-utilization.png';
import LightEnPresenceDependentLcTile from './light-en/presence-dependent-light-control.png';
import LightEnPublicTransportTile from './light-en/public-transport.png';
import LightEnRealTimeNoiseMeasurementsTile from './light-en/real-time-noise-measurements.png';
import LightEnRenewableEnergyTile from './light-en/renewable-energy.png';
import LightEnSensorManagerTile from './light-en/sensor-manager.png';
import LightEnSensorStationATile from './light-en/sensor-station-a.png';
import LightEnSmartChargingTile from './light-en/smart-charging.png';
import LightEnSmartHomeTile from './light-en/smart-home.png';
import LightEnSmartIrrigationTile from './light-en/smart-irrigation.png';
import LightEnSmartLighting1Tile from './light-en/smart-lighting-1.png';
import LightEnSmartLighting2Tile from './light-en/smart-lighting-2.png';
import LightEnSmartParkingTile from './light-en/smart-parking.png';
import LightEnSmartWifiTile from './light-en/smart-wifi.png';
import LightEnSolarEnergyTile from './light-en/solar-energy.png';
import LightEnTemperatureTile from './light-en/temperature.png';
import LightEnTestingWasteContainerTile from './light-en/testing-waste-container.png';
import LightEnTraffic1Tile from './light-en/parking-1.png';
import LightEnTraffic2Tile from './light-en/traffic-2.png';
import LightEnTrafficDependentLcTile from './light-en/traffic-dependent-light-control.png';
import LightEnTrafficInformationTile from './light-en/traffic-information.png';
import LightEnUpcomingProjects1Tile from './light-en/upcoming-projects-1.png';
import LightEnUrbanTrashCanTile from './light-en/urban-trash-cans.png';
import LightEnVaccinationsTile from './light-en/vaccinations.png';
import LightEnWaterConsumptionTile from './light-en/water-consumption.png';
import LightEnWaterLevelsTile from './light-en/water-levels.png';

//dark theme (Special Mode DE)
import DarkDeAmountOfWasteSpecialModeTile from './dark-de-special/abfallmenge.png';
import DarkDeCityInfoSpecialMode from './dark-de-special/stadtinformationen.png';
import DarkDeCurrentWeatherSpecialMode from './dark-de-special/aktuelles-wetter.png';
import DarkDeUpcomingProjectsSpecialMode from './dark-de-special/kommende-projekte.png';
import DarkDeDigitalCityTourTileSpecialMode from './dark-de-special/digitaler-stadtrundgang.png';
import DarkDePlaceUtilizationTileSpecialMode from './dark-de-special/flächennutzung.png';
import DarkDeNoisePollution1TileSpecialMode from './dark-de-special/lärmbelastung.png';
import DarkDeParkingTileSpecialMode from './dark-de-special/parken.png';
import DarkDeSmartChargingTileSpecialMode from './dark-de-special/smartes-laden.png';
import DarkDeSmartLighting1TileSpecialMode from './dark-de-special/smart-lighting.png';
import DarkDeUrbanTrashCanTileSpecialMode from './dark-de-special/städtische-mülleimer.png';
import DarkDeEnvironment1TileSpecialMode from './dark-de-special/umwelt-1.png';
import DarkDeEnvironment3TileSpecialMode from './dark-de-special/umwelt-3.png';
import DarkDeEnvironment6TileSpecialMode from './dark-de-special/umwelt-6.png';
import DarkDeWatersLevelTileSpecialMode from './dark-de-special/wasserstände.png';

// Dark theme (Special Mode EN)
import DarkEnAmountOfWasteSpecialModeTile from './dark-en-special/amount-of-waste.png';
import DarkEnCityInfoSpecialMode from './dark-en-special/city-info.png';
import DarkEnCurrentWeatherSpecialMode from './dark-en-special/current-weather.png';
import DarkEnUpcomingProjectsSpecialMode from './dark-en-special/upcoming-projects-1.png';
import DarkEnDigitalCityTourTileSpecialMode from './dark-en-special/digital-city-tour.png';
import DarkEnPlaceUtilizationTileSpecialMode from './dark-en-special/place-utilization.png';
import DarkEnNoisePollution1TileSpecialMode from './dark-en-special/noise-pollution.png';
import DarkEnParkingTileSpecialMode from './dark-en-special/parking.png';
import DarkEnSmartChargingTileSpecialMode from './dark-en-special/smart-charging.png';
import DarkEnSmartLighting1TileSpecialMode from './dark-en-special/smart-lighting-1.png';
import DarkEnUrbanTrashCanTileSpecialMode from './dark-en-special/urban-trash-cans.png';
import DarkEnEnvironment1TileSpecialMode from './dark-en-special/environment-1.png';
import DarkEnEnvironment3TileSpecialMode from './dark-en-special/environment-3.png';
import DarkEnEnvironment6TileSpecialMode from './dark-en-special/environment-6.png';
import DarkEnWaterLevelsTileSpecialMode from './dark-en-special/water-levels.png';

//dark theme (de)
import DarkDe7DayIncidenceTile from './dark-de/7-tage-inzidenz.png';
import DarkDeAmountOfWasteTile from './dark-de/abfallmenge.png';
import DarkDeAstroClockTile from './dark-de/astrouhr.png';
import DarkDeBrightnessControlTile from './dark-de/helligkeitssteuerung.png';
import DarkDeChargingStationsTile from './dark-de/lade-stationen.png';
import DarkDeCitizenParticipationTile from './dark-de/bürgerbeteiligung.png';
import DarkDeCityInfo from './dark-de/stadtinformationen.png';
import DarkDeCo2Savings1Tile from './dark-de/co2-einsparungen.png';
import DarkDeCo2Savings2Tile from './dark-de/CO2-einsparung.png';
import DarkDeCoronaInformTile from './dark-de/corona inform..png';
import DarkDeCovid19SituationTile from './dark-de/covid-19-situation.png';
import DarkDeCrossfleetTile from './dark-de/crossfleet.png';
import DarkDeCurrentWeatherTile from './dark-de/aktuelles-wetter.png';
import DarkDeCustomerRequestsTile from './dark-de/serviceaufträge.png';
import DarkDeDataTrafficCamerasTile from './dark-de/daten-verkehrskameras.png';
import DarkDeDeceasedTile from './dark-de/verstorbene.png';
import DarkDeDigitalCityTourTile from './dark-de/digitaler-stadtrundgang.png';
import DarkDeDigitalFieldsOfActionTile from './dark-de/digitale-handlungsfelder.png';
import DarkDeDomainSpecificLanguageTile from './dark-de/domänenspezifische-sprache.png';
import DarkDeEnergyHistoryTile from './dark-de/energie-historie.png';
import DarkDeEnergyMix2020Tile from './dark-de/energiemix.png';
import DarkDeEnergySavingsTile from './dark-de/energieeinsparung.png';
import DarkDeEnergyTile from './dark-de/energie.png';
import DarkDeEnvironment1Tile from './dark-de/umwelt-1.png';
import DarkDeEnvironment2Tile from './dark-de/umwelt-2-double.png';
import DarkDeEnvironment3Tile from './dark-de/umwelt-3.png';
import DarkDeEnvironment4Tile from './dark-de/umwelt-4.png';
import DarkDeEnvironment5Tile from './dark-de/umwelt-5.png';
import DarkDeEnvironment6Tile from './dark-de/umwelt-6.png';
import DarkDeEventsTile from './dark-de/veranstaltungen.png';
import DarkDeInfectedTile from './dark-de/infizierte.png';
import DarkDeMobilityStationTile from './dark-de/mobilitätstation.png';
import DarkDeModalSplitTile from './dark-de/Verkehrsmittel.png';
import DarkDeMyConsumptionTile from './dark-de/mein-verbrauch.png';
import DarkDeNetworkOfNeighborhoodsTile from './dark-de/quartiersnetzwerk.png';
import DarkDeNoiseMeasurementHistoryTile from './dark-de/geräuschmessungsverlauf.png';
import DarkDeNoisePollution1Tile from './dark-de/lärmbelastung.png';
import DarkDeNoisePollution2Tile from './dark-de/luftqualität.png';
import DarkDeNoisePollution3Tile from './dark-de/lärmmessung.png';
import DarkDeOpenDataPortalTile from './dark-de/open-data-portal.png';
import DarkDeOverviewTile from './dark-de/übersicht.png';
import DarkDeOwnSupplyOfEnergyTile from './dark-de/eigenversorgung-energie.png';
import DarkDeParkingSpacesTile from './dark-de/parkhäuser.png';
import DarkDeParkingTile from './dark-de/parken.png';
import DarkDePlaceUtilizationTile from './dark-de/flächennutzung.png';
import DarkDePresenceDependentLcTile from './dark-de/präsenzabhängige-lichtsteuerung.png';
import DarkDePublicTransportTile from './dark-de/öffentlicher-verkehr.png';
import DarkDeRealTimeNoiseMeasurementsTile from './dark-de/echtzeit-rauschmessungen.png';
import DarkDeRenewableEnergyTile from './dark-de/erneuerbare-energien.png';
import DarkDeSensorManagerTile from './dark-de/sensormanager.png';
import DarkDeSensorStationATile from './dark-de/sensor-station-a.png';
import DarkDeSmartChargingTile from './dark-de/smartes-laden.png';
import DarkDeSmartHomeTile from './dark-de/intelligentes-zuhause.png';
import DarkDeSmartIrrigationTile from './dark-de/smarte-bewässerung.png';
import DarkDeSmartLighting1Tile from './dark-de/smart-lighting-1.png';
import DarkDeSmartLighting2Tile from './dark-de/smart-lighting-2.png';
import DarkDeSmartParkingTile from './dark-de/smart-parking.png';
import DarkDeSmartWifiTile from './dark-de/smart-wifi.png';
import DarkDeSolarEnergyTile from './dark-de/solarenergie.png';
import DarkDeTemperatureTile from './dark-de/temperatur.png';
import DarkDeTestingWasteContainerTile from './dark-de/abfallbehälter.png';
import DarkDeTraffic1Tile from './dark-de/verkehr-1.png';
import DarkDeTraffic2Tile from './dark-de/verkehr-2.png';
import DarkDeTrafficDependentLcTile from './dark-de/verkehrsabhÄngige.png';
import DarkDeTrafficInformationTile from './dark-de/verkehrsinformationen.png';
import DarkDeUpcomingProjects1Tile from './dark-de/kommende-projekte-1.png';
import DarkDeUrbanTrashCanTile from './dark-de/städtische-mülleimer.png';
import DarkDeVaccinationsTile from './dark-de/impfungen.png';
import DarkDeWaterConsumptionTile from './dark-de/wasserverbrauch.png';
import DarkDeWaterLevelsTile from './dark-de/wasserstände.png';
import DarkDePulseTile from './dark-de/pulse.gif';
import DarkDeLogoTile from './dark-de/logo-ui-solo-white.png';

// Dark Theme (En)
import DarkEn7DayIncidenceTile from './dark-en/7-day-incidence.png';
import DarkEnAmountOfWasteTile from './dark-en/amount-of-waste.png';
import DarkEnAstroClockTile from './dark-en/astroclock.png';
import DarkEnBrightnessControlTile from './dark-en/brightness-control.png';
import DarkEnChargingStationsTile from './dark-en/charging-station.png';
import DarkEnCitizenParticipationTile from './dark-en/upcoming-projects-2.png';
import DarkEnCityInfo from './dark-en/city-info.png';
import DarkEnCo2Savings1Tile from './dark-en/CO2-savings.png';
import DarkEnCo2Savings2Tile from './dark-en/co2-savings-2.png';
import DarkEnCoronaInformTile from './dark-en/corona inform..png';
import DarkEnCovid19SituationTile from './dark-en/covid-19-situation.png';
import DarkEnCrossfleetTile from './dark-en/crossfleet.png';
import DarkEnCurrentWeatherTile from './dark-en/current-weather.png';
import DarkEnCustomerRequestsTile from './dark-en/customer-requests.png';
import DarkEnDataTrafficCamerasTile from './dark-en/data-traffic-cameras.png';
import DarkEnDeceasedTile from './dark-en/deceased.png';
import DarkEnDigitalCityTourTile from './dark-en/digital-city-tour.png';
import DarkEnDigitalFieldsOfActionTile from './dark-en/digital-fields-of-action.png';
import DarkEnDomainSpecificLanguageTile from './dark-en/domain-specific-language.png';
import DarkEnEnergyHistoryTile from './dark-en/energy-history.png';
import DarkEnEnergyMix2020Tile from './dark-en/energy-mix.png';
import DarkEnEnergySavingsTile from './dark-en/energy-savings.png';
import DarkEnEnergyTile from './dark-en/energy.png';
import DarkEnEnvironment1Tile from './dark-en/environment-1.png';
import DarkEnEnvironment2Tile from './dark-en/environment-2-double.png';
import DarkEnEnvironment3Tile from './dark-en/environment-3.png';
import DarkEnEnvironment4Tile from './dark-en/environment-4.png';
import DarkEnEnvironment5Tile from './dark-en/environment-5.png';
import DarkEnEnvironment6Tile from './dark-en/environment-6.png';
import DarkEnEventsTile from './dark-en/events.png';
import DarkEnInfectedTile from './dark-en/infected.png';
import DarkEnMobilityStationTile from './dark-en/mobility-station.png';
import DarkEnModalSplitTile from './dark-en/modal-split.png';
import DarkEnMyConsumptionTile from './dark-en/my-consumption.png';
import DarkEnNetworkOfNeighborhoodsTile from './dark-en/network-of-neighborhoods.png';
import DarkEnNoiseMeasurementHistoryTile from './dark-en/noise-measurement-history.png';
import DarkEnNoisePollution1Tile from './dark-en/noise-pollution-1.png';
import DarkEnNoisePollution2Tile from './dark-en/air-quality.png';
import DarkEnNoisePollution3Tile from './dark-en/noise-measurement.png';
import DarkEnOpenDataPortalTile from './dark-en/open-data-portal.png';
import DarkEnOverviewTile from './dark-en/overview.png';
import DarkEnOwnSupplyOfEnergyTile from './dark-en/own-supply-of-energy.png';
import DarkEnParkingSpacesTile from './dark-en/parking-spaces.png';
import DarkEnParkingTile from './dark-en/parking.png';
import DarkEnPlaceUtilizationTile from './dark-en/place-utilization.png';
import DarkEnPresenceDependentLcTile from './dark-en/presence-dependent-light-control.png';
import DarkEnPublicTransportTile from './dark-en/public-transport.png';
import DarkEnRealTimeNoiseMeasurementsTile from './dark-en/real-time-noise-measurements.png';
import DarkEnRenewableEnergyTile from './dark-en/renewable-energy.png';
import DarkEnSensorManagerTile from './dark-en/sensor-manager.png';
import DarkEnSensorStationATile from './dark-en/sensor-station-a.png';
import DarkEnSmartChargingTile from './dark-en/smart-charging.png';
import DarkEnSmartHomeTile from './dark-en/smart-home.png';
import DarkEnSmartIrrigationTile from './dark-en/smart-irrigation.png';
import DarkEnSmartLighting1Tile from './dark-en/smart-lighting-1.png';
import DarkEnSmartLighting2Tile from './dark-en/smart-lighting-2.png';
import DarkEnSmartParkingTile from './dark-en/smart-parking.png';
import DarkEnSmartWifiTile from './dark-en/smart-wifi.png';
import DarkEnSolarEnergyTile from './dark-en/solar-energy.png';
import DarkEnTemperatureTile from './dark-en/temperature.png';
import DarkEnTestingWasteContainerTile from './dark-en/testing-waste-container.png';
import DarkEnTraffic1Tile from './dark-en/traffic-1.png';
import DarkEnTraffic2Tile from './dark-en/traffic-2.png';
import DarkEnTrafficDependentLcTile from './dark-en/traffic-dependent-light-control.png';
import DarkEnTrafficInformationTile from './dark-en/traffic-information.png';
import DarkEnUpcomingProjects1Tile from './dark-en/upcoming-projects-1.png';
import DarkEnUrbanTrashCanTile from './dark-en/urban-trash-cans.png';
import DarkEnVaccinationsTile from './dark-en/vaccinations.png';
import DarkEnWaterConsumptionTile from './dark-en/water-consumption.png';
import DarkEnWaterLevelsTile from './dark-en/water-levels.png';

//Financial dark theme
import DarkEngFinancialPlaceholder from './placeholders/financial-balance-development-dark.png';
import DarkIntercommunalPlaceholder from './placeholders/financial-balance-intercommunal-dark.png';
import DarkBudgetBalanceComparisonPlaceholder from './placeholders/financial-budget-balance-comparison-dark.png';
import DarkBudgetBalancePlaceholder from './placeholders/financial-budget-balance-dark.png';
import DarkDeviationPlaceholder from './placeholders/financial-deviation-dark.png';
import DarkOrdinaryExpensesPlaceholder from './placeholders/financial-ordinary-expenses-dark.png';
import DarkOrdinaryIncomePlaceholder from './placeholders/financial-ordinary-income-dark.png';
import DarkOverviewPlaceholder from './placeholders/financial-overview-dark.png';
import DarkPropertyPlaceholder from './placeholders/financial-property-tax-B-dark.png';
import DarkReservesPlaceholder from './placeholders/financial-reserves-dark.png';
//Financial light theme
import LightDeFinancialPlaceholder from './placeholders/financial-balance-development-light.png';
import LightIntercommunalPlaceholder from './placeholders/financial-balance-intercommunal-light.png';
import LightBudgetBalanceComparisonPlaceholder from './placeholders/financial-budget-balance-comparison-light.png';
import LightBudgetBalancePlaceholder from './placeholders/financial-budget-balance-light.png';
import LightDeviationPlaceholder from './placeholders/financial-deviation-light.png';
import LightOrdinaryExpensesPlaceholder from './placeholders/financial-ordinary-expenses-light.png';
import LightOrdinaryIncomePlaceholder from './placeholders/financial-ordinary-income-light.png';
import LightOverviewPlaceholder from './placeholders/financial-overview-light.png';
import LightPropertyPlaceholder from './placeholders/financial-property-tax-B-light.png';
import LightReservesPlaceholder from './placeholders/financial-reserves-light.png';


import LightEngFinancialPlaceholder from './placeholders/financial-placeholder-en-light.png';
// import LightDeFinancialPlaceholder from './placeholders/financial-placeholder-de-light.png';

export const tiles: any = {
  light: {
    DE: {
      'financial-placeholder-0': LightDeFinancialPlaceholder,
      'financial-placeholder-1': LightIntercommunalPlaceholder,
      'financial-placeholder-2': LightBudgetBalanceComparisonPlaceholder,
      'financial-placeholder-3': LightBudgetBalancePlaceholder,
      'financial-placeholder-4': LightDeviationPlaceholder,
      'financial-placeholder-5': LightOrdinaryExpensesPlaceholder,
      'financial-placeholder-6': LightOrdinaryIncomePlaceholder,
      'financial-placeholder-7': LightOverviewPlaceholder,
      'financial-placeholder-8': LightPropertyPlaceholder,
      'financial-placeholder-9': LightReservesPlaceholder,
      pulse: LightDePulseTile,
      logo: LightDeLogoTile,
      temperature: LightDeTemperatureTile,
      '7-day-incidence': LightDe7DayIncidenceTile,
      'amount-of-waste': LightDeAmountOfWasteTile,
      'amount-of-waste-special-mode': LightDeAmountOfWasteSpecialModeTile,
      astroclock: LightDeAstroClockTile,
      'brightness-control': LightDeBrightnessControlTile,
      'charging-stations': LightDeChargingStationsTile,
      'citizen-participation': LightDeCitizenParticipationTile,
      'city-info': LightDeCityInfo,
      'city-info-special-mode': LightDeCityInfoSpecialMode,
      'co2-savings-1': LightDeCo2Savings1Tile,
      'co2-savings-2': LightDeCo2Savings2Tile,
      'corona-inform': LightDeCoronaInformTile,
      'covid-19-situation': LightDeCovid19SituationTile,
      crossfleet: LightDeCrossfleetTile,
      'current-weather': LightDeCurrentWeatherTile,
      'customer-requests': LightDeCustomerRequestsTile,
      'current-weather-special-mode': LightDeCurrentWeatherSpecialMode,
      'data-traffic-cameras': LightDeDataTrafficCamerasTile,
      deceased: LightDeDeceasedTile,
      'digital-city-tour': LightDeDigitalCityTourTile,
      'digital-city-tour-special-mode': LightDeDigitalCityTourTileSpecialMode,
      'digital-fields-of-action': LightDeDigitalFieldsOfActionTile,
      'domain-specific-language': LightDeDomainSpecificLanguageTile,
      energy: LightDeEnergyTile,
      'energy-history': LightDeEnergyHistoryTile,
      'energy-mix-2020': LightDeEnergyMix2020Tile,
      'energy-savings': LightDeEnergySavingsTile,
      'environment-1': LightDeEnvironment1Tile,
      'environment-1-special-mode': LightDeEnvironment1TileSpecialMode,
      'environment-2': LightDeEnvironment2Tile,
      'environment-3': LightDeEnvironment3Tile,
      'environment-3-special-mode': LightDeEnvironment3TileSpecialMode,
      'environment-4': LightDeEnvironment4Tile,
      'environment-5': LightDeEnvironment5Tile,
      'environment-6': LightDeEnvironment6Tile,
      'environment-6-special-mode': LightDeEnvironment6TileSpecialMode,
      events: LightDeEventsTile,
      infected: LightDeInfectedTile,
      'mobility-station': LightDeMobilityStationTile,
      'modal-split': LightDeModalSplitTile,
      'my-consumption': LightDeMyConsumptionTile,
      'network-of-neighborhoods': LightDeNetworkOfNeighborhoodsTile,
      'noise-measurement-history': LightDeNoiseMeasurementHistoryTile,
      'noise-pollution-1': LightDeNoisePollution1Tile,
      'noise-pollution-1-special-mode': LightDeNoisePollution1TileSpecialMode,
      'noise-pollution-2': LightDeNoisePollution2Tile,
      'noise-pollution-3': LightDeNoisePollution3Tile,
      'open-data-portal': LightDeOpenDataPortalTile,
      overview: LightDeOverviewTile,
      'own-supply-of-energy': LightDeOwnSupplyOfEnergyTile,
      parking: LightDeParkingTile,
      'parking-special-mode': LightDeParkingTileSpecialMode,
      'parking-spaces': LightDeParkingSpacesTile,
      'place-utilization': LightDePlaceUtilizationTile,
      'place-utilization-special-mode': LightDePlaceUtilizationTileSpecialMode,
      'presence-dependent-lc': LightDePresenceDependentLcTile,
      'public-transport': LightDePublicTransportTile,
      'real-time-noise-measurements': LightDeRealTimeNoiseMeasurementsTile,
      'renewable-energy': LightDeRenewableEnergyTile,
      'sensor-manager': LightDeSensorManagerTile,
      'sensor-station-a': LightDeSensorStationATile,
      'smart-charging': LightDeSmartChargingTile,
      'smart-charging-special-mode': LightDeSmartChargingTileSpecialMode,
      'smart-home': LightDeSmartHomeTile,
      'smart-irrigation': LightDeSmartIrrigationTile,
      'smart-lighting-1': LightDeSmartLighting1Tile,
      'smart-lighting-1-special-mode': LightDeSmartLighting1TileSpecialMode,
      'smart-lighting-2': LightDeSmartLighting2Tile,
      'smart-parking': LightDeSmartParkingTile,
      'smart-wifi': LightDeSmartWifiTile,
      'solar-energy': LightDeSolarEnergyTile,
      'testing-waste-container': LightDeTestingWasteContainerTile,
      'traffic-1': LightDeTraffic1Tile,
      'traffic-2': LightDeTraffic2Tile,
      'traffic-dependent-lc': LightDeTrafficDependentLcTile,
      'traffic-information': LightDeTrafficInformationTile,
      'upcoming-projects-1': LightDeUpcomingProjects1Tile,
      'upcoming-projects-1-special-mode': LightDeUpcomingProjectsSpecialMode,
      'urban-trash-can': LightDeUrbanTrashCanTile,
      'urban-trash-can-special-mode': LightDeUrbanTrashCanTileSpecialMode,
      vaccinations: LightDeVaccinationsTile,
      'water-consumption': LightDeWaterConsumptionTile,
      'water-levels-special-mode': LightDeWaterLevelsTileSpecialMode,
      'water-levels': LightDeWaterLevelsTile
    },
    EN: {
      'financial-placeholder-0': LightDeFinancialPlaceholder,
      'financial-placeholder-1': LightIntercommunalPlaceholder,
      'financial-placeholder-2': LightBudgetBalanceComparisonPlaceholder,
      'financial-placeholder-3': LightBudgetBalancePlaceholder,
      'financial-placeholder-4': LightDeviationPlaceholder,
      'financial-placeholder-5': LightOrdinaryExpensesPlaceholder,
      'financial-placeholder-6': LightOrdinaryIncomePlaceholder,
      'financial-placeholder-7': LightOverviewPlaceholder,
      'financial-placeholder-8': LightPropertyPlaceholder,
      'financial-placeholder-9': LightReservesPlaceholder,
      pulse: LightDePulseTile,
      logo: LightDeLogoTile,
      temperature: LightEnTemperatureTile,
      '7-day-incidence': LightEn7DayIncidenceTile,
      'amount-of-waste': LightEnAmountOfWasteTile,
      'amount-of-waste-special-mode': LightEnAmountOfWasteSpecialModeTile,
      astroclock: LightEnAstroClockTile,
      'brightness-control': LightEnBrightnessControlTile,
      'charging-stations': LightEnChargingStationsTile,
      'citizen-participation': LightEnCitizenParticipationTile,
      'city-info': LightEnCityInfo,
      'city-info-special-mode': LightEnCityInfoSpecialMode,
      'co2-savings-1': LightEnCo2Savings1Tile,
      'co2-savings-2': LightEnCo2Savings2Tile,
      'corona-inform': LightEnCoronaInformTile,
      'covid-19-situation': LightEnCovid19SituationTile,
      crossfleet: LightEnCrossfleetTile,
      'current-weather': LightEnCurrentWeatherTile,
      'customer-requests': LightEnCustomerRequestsTile,
      'current-weather-special-mode': LightEnCurrentWeatherSpecialMode,
      'data-traffic-cameras': LightEnDataTrafficCamerasTile,
      deceased: LightEnDeceasedTile,
      'digital-city-tour': LightEnDigitalCityTourTile,
      'digital-city-tour-special-mode': LightEnDigitalCityTourTileSpecialMode,
      'digital-fields-of-action': LightEnDigitalFieldsOfActionTile,
      'domain-specific-language': LightEnDomainSpecificLanguageTile,
      energy: LightEnEnergyTile,
      'energy-history': LightEnEnergyHistoryTile,
      'energy-mix-2020': LightEnEnergyMix2020Tile,
      'energy-savings': LightEnEnergySavingsTile,
      'environment-1': LightEnEnvironment1Tile,
      'environment-1-special-mode': LightEnEnvironment1TileSpecialMode,
      'environment-2': LightEnEnvironment2Tile,
      'environment-3': LightEnEnvironment3Tile,
      'environment-3-special-mode': LightEnEnvironment3TileSpecialMode,
      'environment-4': LightEnEnvironment4Tile,
      'environment-5': LightEnEnvironment5Tile,
      'environment-6': LightEnEnvironment6Tile,
      'environment-6-special-mode': LightEnEnvironment6TileSpecialMode,
      events: LightEnEventsTile,
      infected: LightEnInfectedTile,
      'mobility-station': LightEnMobilityStationTile,
      'modal-split': LightEnModalSplitTile,
      'my-consumption': LightEnMyConsumptionTile,
      'network-of-neighborhoods': LightEnNetworkOfNeighborhoodsTile,
      'noise-measurement-history': LightEnNoiseMeasurementHistoryTile,
      'noise-pollution-1': LightEnNoisePollution1Tile,
      'noise-pollution-1-special-mode': LightEnNoisePollution1TileSpecialMode,
      'noise-pollution-2': LightEnNoisePollution2Tile,
      'noise-pollution-3': LightEnNoisePollution3Tile,
      'open-data-portal': LightEnOpenDataPortalTile,
      overview: LightEnOverviewTile,
      'own-supply-of-energy': LightEnOwnSupplyOfEnergyTile,
      parking: LightEnParkingTile,
      'parking-special-mode': LightEnParkingTileSpecialMode,
      'parking-spaces': LightEnParkingSpacesTile,
      'place-utilization': LightEnPlaceUtilizationTile,
      'place-utilization-special-mode': LightEnPlaceUtilizationTileSpecialMode,
      'presence-dependent-lc': LightEnPresenceDependentLcTile,
      'public-transport': LightEnPublicTransportTile,
      'real-time-noise-measurements': LightEnRealTimeNoiseMeasurementsTile,
      'renewable-energy': LightEnRenewableEnergyTile,
      'sensor-manager': LightEnSensorManagerTile,
      'sensor-station-a': LightEnSensorStationATile,
      'smart-charging': LightEnSmartChargingTile,
      'smart-charging-special-mode': LightEnSmartChargingTileSpecialMode,
      'smart-home': LightEnSmartHomeTile,
      'smart-irrigation': LightEnSmartIrrigationTile,
      'smart-lighting-1': LightEnSmartLighting1Tile,
      'smart-lighting-1-special-mode': LightEnSmartLighting1TileSpecialMode,
      'smart-lighting-2': LightEnSmartLighting2Tile,
      'smart-parking': LightEnSmartParkingTile,
      'smart-wifi': LightEnSmartWifiTile,
      'solar-energy': LightEnSolarEnergyTile,
      'testing-waste-container': LightEnTestingWasteContainerTile,
      'traffic-1': LightEnTraffic1Tile,
      'traffic-2': LightEnTraffic2Tile,
      'traffic-dependent-lc': LightEnTrafficDependentLcTile,
      'traffic-information': LightEnTrafficInformationTile,
      'upcoming-projects-1': LightEnUpcomingProjects1Tile,
      'upcoming-projects-1-special-mode': LightEnUpcomingProjectsSpecialMode,
      'urban-trash-can': LightEnUrbanTrashCanTile,
      'urban-trash-can-special-mode': LightEnUrbanTrashCanTileSpecialMode,
      vaccinations: LightEnVaccinationsTile,
      'water-consumption': LightEnWaterConsumptionTile,
      'water-levels-special-mode': LightEnWaterLevelsTileSpecialMode,
      'water-levels': LightEnWaterLevelsTile
    }
  },


  dark: {
    DE: {
      'financial-placeholder-0': DarkEngFinancialPlaceholder,
      'financial-placeholder-1': DarkIntercommunalPlaceholder,
      'financial-placeholder-2': DarkBudgetBalanceComparisonPlaceholder,
      'financial-placeholder-3': DarkBudgetBalancePlaceholder,
      'financial-placeholder-4': DarkDeviationPlaceholder,
      'financial-placeholder-5': DarkOrdinaryExpensesPlaceholder,
      'financial-placeholder-9': DarkOrdinaryIncomePlaceholder,
      'financial-placeholder-6': DarkOverviewPlaceholder,
      'financial-placeholder-7': DarkPropertyPlaceholder,
      'financial-placeholder-8': DarkReservesPlaceholder,
      pulse: DarkDePulseTile,
      logo: DarkDeLogoTile,
      '7-day-incidence': DarkDe7DayIncidenceTile,
      'amount-of-waste': DarkDeAmountOfWasteTile,
      'amount-of-waste-special-mode': DarkDeAmountOfWasteSpecialModeTile,
      astroclock: DarkDeAstroClockTile,
      'brightness-control': DarkDeBrightnessControlTile,
      'charging-stations': DarkDeChargingStationsTile,
      'citizen-participation': DarkDeCitizenParticipationTile,
      'city-info-special-mode': DarkDeCityInfoSpecialMode,
      'city-info': DarkDeCityInfo,
      'co2-savings-1': DarkDeCo2Savings1Tile,
      'co2-savings-2': DarkDeCo2Savings2Tile,
      'corona-inform': DarkDeCoronaInformTile,
      'covid-19-situation': DarkDeCovid19SituationTile,
      crossfleet: DarkDeCrossfleetTile,
      'current-weather': DarkDeCurrentWeatherTile,
      'customer-requests': DarkDeCustomerRequestsTile,
      'data-traffic-cameras': DarkDeDataTrafficCamerasTile,
      'current-weather-special-mode': DarkDeCurrentWeatherSpecialMode,
      deceased: DarkDeDeceasedTile,
      'digital-city-tour': DarkDeDigitalCityTourTile,
      'digital-city-tour-special-mode': DarkDeDigitalCityTourTileSpecialMode,
      'digital-fields-of-action': DarkDeDigitalFieldsOfActionTile,
      'domain-specific-language': DarkDeDomainSpecificLanguageTile,
      energy: DarkDeEnergyTile,
      'energy-history': DarkDeEnergyHistoryTile,
      'energy-mix-2020': DarkDeEnergyMix2020Tile,
      'energy-savings': DarkDeEnergySavingsTile,
      'environment-1': DarkDeEnvironment1Tile,
      'environment-1-special-mode': DarkDeEnvironment1TileSpecialMode,
      'environment-2': DarkDeEnvironment2Tile,
      'environment-3': DarkDeEnvironment3Tile,
      'environment-3-special-mode': DarkDeEnvironment3TileSpecialMode,
      'environment-4': DarkDeEnvironment4Tile,
      'environment-5': DarkDeEnvironment5Tile,
      'environment-6': DarkDeEnvironment6Tile,
      'environment-6-special-mode': DarkDeEnvironment6TileSpecialMode,
      events: DarkDeEventsTile,
      infected: DarkDeInfectedTile,
      'mobility-station': DarkDeMobilityStationTile,
      'modal-split': DarkDeModalSplitTile,
      'my-consumption': DarkDeMyConsumptionTile,
      'network-of-neighborhoods': DarkDeNetworkOfNeighborhoodsTile,
      'noise-measurement-history': DarkDeNoiseMeasurementHistoryTile,
      'noise-pollution-1': DarkDeNoisePollution1Tile,
      'noise-pollution-1-special-mode': DarkDeNoisePollution1TileSpecialMode,
      'noise-pollution-2': DarkDeNoisePollution2Tile,
      'noise-pollution-3': DarkDeNoisePollution3Tile,
      'open-data-portal': DarkDeOpenDataPortalTile,
      overview: DarkDeOverviewTile,
      'own-supply-of-energy': DarkDeOwnSupplyOfEnergyTile,
      parking: DarkDeParkingTile,
      'parking-special-mode': DarkDeParkingTileSpecialMode,
      'parking-spaces': DarkDeParkingSpacesTile,
      'place-utilization': DarkDePlaceUtilizationTile,
      'place-utilization-special-mode': DarkDePlaceUtilizationTileSpecialMode,
      'presence-dependent-lc': DarkDePresenceDependentLcTile,
      'public-transport': DarkDePublicTransportTile,
      'real-time-noise-measurements': DarkDeRealTimeNoiseMeasurementsTile,
      'renewable-energy': DarkDeRenewableEnergyTile,
      'sensor-manager': DarkDeSensorManagerTile,
      'sensor-station-a': DarkDeSensorStationATile,
      'smart-charging': DarkDeSmartChargingTile,
      'smart-charging-special-mode': DarkDeSmartChargingTileSpecialMode,
      'smart-home': DarkDeSmartHomeTile,
      'smart-irrigation': DarkDeSmartIrrigationTile,
      'smart-lighting-1': DarkDeSmartLighting1Tile,
      'smart-lighting-1-special-mode': DarkDeSmartLighting1TileSpecialMode,
      'smart-lighting-2': DarkDeSmartLighting2Tile,
      'smart-parking': DarkDeSmartParkingTile,
      'smart-wifi': DarkDeSmartWifiTile,
      'solar-energy': DarkDeSolarEnergyTile,
      temperature: DarkDeTemperatureTile,
      'testing-waste-container': DarkDeTestingWasteContainerTile,
      'traffic-1': DarkDeTraffic1Tile,
      'traffic-2': DarkDeTraffic2Tile,
      'traffic-dependent-lc': DarkDeTrafficDependentLcTile,
      'traffic-information': DarkDeTrafficInformationTile,
      'upcoming-projects-1-special-mode': DarkDeUpcomingProjectsSpecialMode,
      'upcoming-projects-1': DarkDeUpcomingProjects1Tile,
      'urban-trash-can': DarkDeUrbanTrashCanTile,
      'urban-trash-can-special-mode': DarkDeUrbanTrashCanTileSpecialMode,
      vaccinations: DarkDeVaccinationsTile,
      'water-consumption': DarkDeWaterConsumptionTile,
      'water-levels-special-mode': DarkDeWatersLevelTileSpecialMode,
      'water-levels': DarkDeWaterLevelsTile
    },
    EN: {
      'financial-placeholder-0': DarkEngFinancialPlaceholder,
      'financial-placeholder-1': DarkIntercommunalPlaceholder,
      'financial-placeholder-2': DarkBudgetBalanceComparisonPlaceholder,
      'financial-placeholder-3': DarkBudgetBalancePlaceholder,
      'financial-placeholder-4': DarkDeviationPlaceholder,
      'financial-placeholder-5': DarkOrdinaryExpensesPlaceholder,
      'financial-placeholder-9': DarkOrdinaryIncomePlaceholder,
      'financial-placeholder-6': DarkOverviewPlaceholder,
      'financial-placeholder-7': DarkPropertyPlaceholder,
      'financial-placeholder-8': DarkReservesPlaceholder,
      pulse: DarkDePulseTile,
      logo: DarkDeLogoTile,
      '7-day-incidence': DarkEn7DayIncidenceTile,
      'amount-of-waste': DarkEnAmountOfWasteTile,
      'amount-of-waste-special-mode': DarkEnAmountOfWasteSpecialModeTile,
      astroclock: DarkEnAstroClockTile,
      'brightness-control': DarkEnBrightnessControlTile,
      'charging-stations': DarkEnChargingStationsTile,
      'citizen-participation': DarkEnCitizenParticipationTile,
      'city-info-special-mode': DarkEnCityInfoSpecialMode,
      'city-info': DarkEnCityInfo,
      'co2-savings-1': DarkEnCo2Savings1Tile,
      'co2-savings-2': DarkEnCo2Savings2Tile,
      'corona-inform': DarkEnCoronaInformTile,
      'covid-19-situation': DarkEnCovid19SituationTile,
      crossfleet: DarkEnCrossfleetTile,
      'current-weather': DarkEnCurrentWeatherTile,
      'customer-requests': DarkEnCustomerRequestsTile,
      'data-traffic-cameras': DarkEnDataTrafficCamerasTile,
      'current-weather-special-mode': DarkEnCurrentWeatherSpecialMode,
      deceased: DarkEnDeceasedTile,
      'digital-city-tour': DarkEnDigitalCityTourTile,
      'digital-city-tour-special-mode': DarkEnDigitalCityTourTileSpecialMode,
      'digital-fields-of-action': DarkEnDigitalFieldsOfActionTile,
      'domain-specific-language': DarkEnDomainSpecificLanguageTile,
      energy: DarkEnEnergyTile,
      'energy-history': DarkEnEnergyHistoryTile,
      'energy-mix-2020': DarkEnEnergyMix2020Tile,
      'energy-savings': DarkEnEnergySavingsTile,
      'environment-1': DarkEnEnvironment1Tile,
      'environment-1-special-mode': DarkEnEnvironment1TileSpecialMode,
      'environment-2': DarkEnEnvironment2Tile,
      'environment-3': DarkEnEnvironment3Tile,
      'environment-3-special-mode': DarkEnEnvironment3TileSpecialMode,
      'environment-4': DarkEnEnvironment4Tile,
      'environment-5': DarkEnEnvironment5Tile,
      'environment-6': DarkEnEnvironment6Tile,
      'environment-6-special-mode': DarkEnEnvironment6TileSpecialMode,
      events: DarkEnEventsTile,
      infected: DarkEnInfectedTile,
      'mobility-station': DarkEnMobilityStationTile,
      'modal-split': DarkEnModalSplitTile,
      'my-consumption': DarkEnMyConsumptionTile,
      'network-of-neighborhoods': DarkEnNetworkOfNeighborhoodsTile,
      'noise-measurement-history': DarkEnNoiseMeasurementHistoryTile,
      'noise-pollution-1': DarkEnNoisePollution1Tile,
      'noise-pollution-1-special-mode': DarkEnNoisePollution1TileSpecialMode,
      'noise-pollution-2': DarkEnNoisePollution2Tile,
      'noise-pollution-3': DarkEnNoisePollution3Tile,
      'open-data-portal': DarkEnOpenDataPortalTile,
      overview: DarkEnOverviewTile,
      'own-supply-of-energy': DarkEnOwnSupplyOfEnergyTile,
      parking: DarkEnParkingTile,
      'parking-special-mode': DarkEnParkingTileSpecialMode,
      'parking-spaces': DarkEnParkingSpacesTile,
      'place-utilization': DarkEnPlaceUtilizationTile,
      'place-utilization-special-mode': DarkEnPlaceUtilizationTileSpecialMode,
      'presence-dependent-lc': DarkEnPresenceDependentLcTile,
      'public-transport': DarkEnPublicTransportTile,
      'real-time-noise-measurements': DarkEnRealTimeNoiseMeasurementsTile,
      'renewable-energy': DarkEnRenewableEnergyTile,
      'sensor-manager': DarkEnSensorManagerTile,
      'sensor-station-a': DarkEnSensorStationATile,
      'smart-charging': DarkEnSmartChargingTile,
      'smart-charging-special-mode': DarkEnSmartChargingTileSpecialMode,
      'smart-home': DarkEnSmartHomeTile,
      'smart-irrigation': DarkEnSmartIrrigationTile,
      'smart-lighting-1': DarkEnSmartLighting1Tile,
      'smart-lighting-1-special-mode': DarkEnSmartLighting1TileSpecialMode,
      'smart-lighting-2': DarkEnSmartLighting2Tile,
      'smart-parking': DarkEnSmartParkingTile,
      'smart-wifi': DarkEnSmartWifiTile,
      'solar-energy': DarkEnSolarEnergyTile,
      temperature: DarkEnTemperatureTile,
      'testing-waste-container': DarkEnTestingWasteContainerTile,
      'traffic-1': DarkEnTraffic1Tile,
      'traffic-2': DarkEnTraffic2Tile,
      'traffic-dependent-lc': DarkEnTrafficDependentLcTile,
      'traffic-information': DarkEnTrafficInformationTile,
      'upcoming-projects-1-special-mode': DarkEnUpcomingProjectsSpecialMode,
      'upcoming-projects-1': DarkEnUpcomingProjects1Tile,
      'urban-trash-can': DarkEnUrbanTrashCanTile,
      'urban-trash-can-special-mode': DarkEnUrbanTrashCanTileSpecialMode,
      vaccinations: DarkEnVaccinationsTile,
      'water-consumption': DarkEnWaterConsumptionTile,
      'water-levels-special-mode': DarkEnWaterLevelsTileSpecialMode,
      'water-levels': DarkEnWaterLevelsTile
    }
  }
};
